<div class="al-loading-spinner">
    <p-progressSpinner class="al-spinner"></p-progressSpinner>
</div>